import { Select, Space } from 'antd'

import { KindDetail } from '@eastcoal/api/system/interface'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { KindAllNodeCascader } from '@eastcoal/shared/@formily/KindAllNodeCascader'

import { ComplaintBanKindSelectProps } from './interface'

const defaultOptions = [
  {
    label: '全部',
    value: true
  },
  {
    label: '指定',
    value: false
  }
]

const Component = ({
  disabled,
  value = {},
  onChange
}: ComplaintBanKindSelectProps) => {
  const handleSelectChange = (prohibitAllKind: boolean) => {
    onChange?.({ kindList: [], prohibitAllKind })
  }

  const handleKindChange = (kindList?: KindDetail[]) => {
    onChange?.({
      ...value,
      kindList
    })
  }

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        allowClear={false}
        disabled={disabled}
        options={defaultOptions}
        value={value.prohibitAllKind}
        style={{
          flex: '0 0 200px'
        }}
        onChange={handleSelectChange}
      />
      <KindAllNodeCascader
        multiple
        disabled={disabled || value.prohibitAllKind}
        value={value.kindList}
        onChange={handleKindChange as any}
      />
    </Space.Compact>
  )
}

export const ComplaintBanKindSelect = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  })
)
